import AdminListToolbar from "../../components/admin/AdminListToolbar";
import AdminPagination from "../../components/admin/AdminPagination";
import { BOOKING_STATUS_FILTERS } from "../../components/admin/adminConstants";
import { formatTripRange } from "../../lib/dateLocal";
import { formatUsd } from "../../lib/currencyDisplay";
import { formatBookingStatus, bookingStatusDotClass } from "../../lib/bookingStatus";

export default function AdminBookingsTab({
  allBookings,
  bookingsStatus,
  bookingsSearchDraft,
  onBookingsSearchDraftChange,
  onBookingsSearch,
  bookingsTotal,
  page,
  totalPages,
  onPageChange,
  onStatusFilter,
}) {
  return (
    <div className="zc-card overflow-hidden overflow-x-auto mt-4 zc-stack-table" data-testid="admin-bookings">
      <div className="px-4 sm:px-6 py-3 border-b border-[var(--zc-border)] flex flex-col gap-3">
        <div className="flex flex-wrap items-center justify-between gap-3">
          <div className="text-xs uppercase tracking-widest text-[var(--zc-text-3)] font-semibold">Bookings</div>
          <div className="flex flex-wrap gap-1" data-testid="admin-bookings-status-filters">
            {BOOKING_STATUS_FILTERS.map((f) => (
              <button
                key={f.id}
                type="button"
                onClick={() => onStatusFilter(f.id)}
                className={
                  "px-3 h-8 text-xs font-semibold rounded-md border transition-colors "
                  + (bookingsStatus === f.id
                    ? "border-[var(--zc-accent)] text-[var(--zc-accent)] bg-[var(--zc-accent-soft)]"
                    : "border-[var(--zc-border)] text-[var(--zc-text-3)] hover:text-[var(--zc-text)]")
                }
                data-testid={`admin-bookings-filter-${f.id}`}
              >
                {f.label}
              </button>
            ))}
          </div>
        </div>
        <AdminListToolbar
          draft={bookingsSearchDraft}
          onDraftChange={onBookingsSearchDraftChange}
          onSearch={onBookingsSearch}
          placeholder="Search by booking ID or renter name…"
          testid="admin-bookings-search"
          total={bookingsTotal}
          shown={allBookings.length}
        />
      </div>
      <div className="hidden md:grid md:grid-cols-[1.5fr,1fr,1fr,1fr,1fr] zc-stack-head px-4 sm:px-6 py-3 text-xs uppercase tracking-widest text-[var(--zc-text-3)] border-b border-[var(--zc-border)] font-semibold">
        <div>Vehicle</div><div>Renter</div><div>Dates</div><div>Total</div><div>Status</div>
      </div>
      {allBookings.length === 0 && (
        <div className="px-6 py-10 text-center text-[var(--zc-text-3)] text-sm">
          {bookingsStatus === "active" ? "No active rentals right now." : "No bookings match this filter."}
        </div>
      )}
      {allBookings.map(b => (
        <div key={b.booking_id} className="zc-stack-row md:grid md:grid-cols-[1.5fr,1fr,1fr,1fr,1fr] md:items-center px-4 sm:px-6 py-3 border-b border-[var(--zc-border)] last:border-0 text-sm">
          <div data-label="Vehicle" className="min-w-0">
            <div className="font-semibold">
              {b.vehicle_snapshot?.make
                ? `${b.vehicle_snapshot?.year || ""} ${b.vehicle_snapshot?.make} ${b.vehicle_snapshot?.model}`.trim()
                : b.vehicle_id || "—"}
            </div>
            <div className="text-2xs font-mono text-[var(--zc-text-3)] mt-0.5 break-all">{b.booking_id}</div>
          </div>
          <div data-label="Renter" className="text-[var(--zc-text-2)] min-w-0">
            <div>{b.renter_name || "—"}</div>
            {b.renter_id && <div className="text-2xs font-mono text-[var(--zc-text-3)] truncate mt-0.5">{b.renter_id}</div>}
          </div>
          <div data-label="Dates" className="text-[var(--zc-text-2)] text-xs break-words">{formatTripRange(b.start_date, b.end_date) || "—"}</div>
          <div data-label="Total" className="font-semibold">${formatUsd(b.total)}</div>
          <div data-label="Status" className="flex items-center gap-2">
            <span className={"dot " + bookingStatusDotClass(b.status)} />
            {formatBookingStatus(b)}
          </div>
        </div>
      ))}
      <AdminPagination page={page} totalPages={totalPages} onPageChange={onPageChange} testid="admin-bookings-pagination" />
    </div>
  );
}
